import { Dispatch, SetStateAction, useEffect, useState } from 'react';
// import { AddBankAccount } from './AddBankAccount';
// import { ChooseBankAccount } from './ChooseBankAccount';
// import { TwoFASetup } from './TwoFASetup';
// import { WithdrawFinalCheck } from './WithdrawFinalCheck';
// import { WithdrawInitial } from './WithdrawInitial';
// import { WithdrawSuccess } from './WithdrawSuccess';
import { useAppSelector } from '../../../app/hooks';
import { WithdrawAmount } from './WithdrawAmount';
import { WithdrawSteps } from '../Earnings/Earnings';
import { WithdrawFinal } from './WithdrawFinal';
import { WithdrawTwoFA } from './WithrawTwoFA';
import { WithdrawSuccess } from './WithdrawSuccess';
// import { Withdraw2FARequired } from './Withdraw2FARequired';
// import { WithdrawAvailability } from './WithdrawAvailability';
// import { WalletActivation } from './Withdraw.types';

interface WithdrawProps {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  setWithdraw: Dispatch<SetStateAction<boolean>>;
  amount: string;
  setAmount: Dispatch<SetStateAction<string>>;
}

export const Withdraw = ({
  step,
  setStep,
  amount,
  setAmount,
  setWithdraw
}: WithdrawProps) => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      {step === WithdrawSteps.FINAL && (
        <WithdrawFinal
          setStep={setStep}
          amount={amount}
          setAmount={setAmount}
        />
      )}
      {step === WithdrawSteps.TWO_FA && (
        <WithdrawTwoFA
          setStep={setStep}
          amount={amount}
          setAmount={setAmount}
        />
      )}
      {step === WithdrawSteps.SUCCESS && (
        <WithdrawSuccess setWithdraw={setWithdraw} />
      )}
    </>
  );
};
